import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';

export const TEMPLATE_PROPERTY_HAS_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idPropertyDefinitionHasRepository',
	singular: 'Reverse Reference Field',
	summary: 'Shows entries from another collection that reference this one.',
};

export const TEMPLATE_PROPERTY_HAS_TEMPLATE_PROPERTIES: PropertyDefinition[] = [{
	id: 'idPropertyDefinitionHasLabelProperty',
	parentId: TEMPLATE_PROPERTY_HAS_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'label',
	label: 'Label',
	required: true,
	autoFocus: true,
}, {
	id: 'idPropertyDefinitionHasSlugProperty',
	parentId: TEMPLATE_PROPERTY_HAS_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'slug',
	label: 'Key',
	required: true,
	disabled: true,
}, {
	id: 'idPropertyDefinitionHasTargetRepositoryIdProperty',
	parentId: TEMPLATE_PROPERTY_HAS_REPOSITORY.id,
	type: EntityType.PropertyDefinitionBelongsTo,
	slug: 'targetRepositoryId',
	label: 'Other collection',
	required: true,
}, {
	id: 'idPropertyDefinitionHasTargetPropertySlugProperty',
	parentId: TEMPLATE_PROPERTY_HAS_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString, // TODO: change that to select
	slug: 'targetPropertySlug',
	label: 'Property (slug)',
	required: true,
}];
